import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResolvableMissionTypeForm_ServiceUsage_Remove_Mutation = graphql(`
  mutation ResolvableMissionTypeForm_ServiceUsage_Remove(
    $serviceUsageId: Id!
    $serviceUserId: Id!
    $serviceUsagesGroupId: Id!
    $versionData: VersionDataInput
  ) {
    removeResolvableMissionTypeServiceUsage(
      serviceUsageId: $serviceUsageId
      serviceUserId: $serviceUserId
      serviceUsagesGroupId: $serviceUsagesGroupId
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useRemoveResolvableMissionTypeServiceUsageMutation = () =>
  useGraphQLMutation(ResolvableMissionTypeForm_ServiceUsage_Remove_Mutation);
